import { useSession } from "./useSession.hook"

export function useIsTeamLeader() {
  const { user } = useSession()
  return user?.isTeamLeader?.() ?? false
}
